import Header from 'components/Headers/Header';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Container, Row } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { ActionPopover } from 'components/Table/ActionTable';
import { CircleStatus } from './status-client';

export function TableGenericClients({ columns, data, disableGlobalFilter }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
  );

  const { globalFilter } = state;

  return (
    <>
      {!disableGlobalFilter && (
        <GlobalFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          urlNewItem={'/client/new'}
        />
      )}
      <Table responsive hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ fontSize: '18px' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '18px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Sem registros de clientes, por gentilza cadastre um cliente!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export const ClientList = () => {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    async function getData() {
      const data = await handleSendGeneric('/v1/client', 'GET');
      if (data !== undefined) {
        setClients(data);
      }
    }

    getData();
  }, []);

  const cacheItemsDisabled = React.useMemo(() => clients, [clients]);

  const columns = useMemo(
    () => [
      {
        Header: 'Razão Social',
        accessor: 'name',
      },
      {
        Header: 'STATUS',
        Cell: ({ ...props }) => {
          const client = props.data[props.row.index];
          return <CircleStatus status={client?.stateClientEnum} />;
        },
      },
      {
        Header: 'Comissão',
        accessor: 'commission',
      },
      {
        Header: 'Cidade',
        accessor: 'city',
      },
      {
        Header: 'Estado',
        accessor: 'state',
      },
      {
        Header: 'Telefone',
        accessor: 'phoneNumber',
      },
      {
        Header: 'Telefone 2',
        accessor: 'phoneNumber2',
      },
      {
        Header: 'Ação',
        Cell: ({ ...props }) => {
          const actionId = props.data[props.row.index]?.id;
          return (
            <ActionPopover
              urlEdit={'/client/' + actionId}
              urlDelete={'/v1/client/'}
              idDelete={actionId}
              listUpdate={setClients}
            />
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Header />
      <Container className='mt--7' fluid>
        <Row>
          <div className='col'>
            <Card className='shadow'>
              <TableGenericClients
                columns={columns}
                data={cacheItemsDisabled}
              />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
